import React, {Component, MouseEventHandler, ReactNode} from 'react'
import {IconButtonSkeleton} from "@App/Components/common/IconButton/IconButtonSkeleton";

type IconButtonProps = {
    icon: ReactNode,
    title: string,
    subtitle?: string,
    loading?: boolean,
    order?: number,
    onClick: MouseEventHandler<HTMLDivElement>
}


export class IconButton extends Component<IconButtonProps> {

    public static defaultProps = {
        loading: false
    }

    render(): ReactNode {

        if (this.props.loading) {
            return <IconButtonSkeleton/>
        }

        return (
            <div
                className={`flex flex-col ${this.props.order ? `order-${this.props.order}` : ''} items-center text-center border border-neutral-500 rounded py-4 px-3 md:px-8 cursor-pointer hover:border-primary md:max-w-[250px] md:w-[250px`}
                onClick={this.props.onClick}>
                <div className="mb-2">
                    {this.props.icon}
                </div>
                <div className="font-serif text-xs md:text-sm hyphens-auto" dangerouslySetInnerHTML={{__html: this.props.title}}/>
                {this.props.subtitle && (
                    <div className={'text-[0.6875rem] text-neutral-500 mt-1'}>{this.props.subtitle}</div>
                )}
            </div>
        )
    }
}
